<template>
  <section class="root-doc">
    <h1 class="root-title">关于解除ROOT的说明</h1>

    <dl class="brand-tiem">
      <dt class="brand-title">什么是ROOT？</dt>

      <dd>
        <p class="desc">ROOT是指安卓手机系统底层的超级权限。部分安卓手机操作系统，以及一部分手机优化软件提供ROOT的功能。如果您使用安卓模拟器进行游戏，一般而言也是开启了ROOT的。</p>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">为什么要解除ROOT？</dt>

      <dd>
        <p class="desc">ROOT过的手机更容易受到恶意第三方软件的影响，影响您以及其它玩家的游戏体验，因此我们建议您解除ROOT后再进入游戏。</p>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">如何解除ROOT？</dt>

      <dd>
        <p class="desc">如果您之前有意开启了ROOT权限，可以通过您之前使用的软件操作关闭ROOT。如果您是无意中开启的ROOT，或者忘记了之前开启ROOT的方式，可以按照下面提供的方式进行操作。下面提供的工具和操作方式只需操作后重启手机即可完成，不会对您手机的数据和功能使用造成影响。如果您有其它疑虑，也可咨询官方客服4009-393-333。</p>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">安卓手机解除ROOT方法</dt>

      <dd>
        <p class="desc">如果您使用的是ROOT过的安卓手机，可以使用以下工具解除ROOT。</p>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">1. 360一键Root工具解除</dt>
      <dd>
        <div class="link-box">
          <span class="title">官方网站</span>
          <a class="link" href="http://root.360.cn">http://root.360.cn</a>
        </div>

        <p class="desc">下载最新版本的手机版本来解除。</p>

        <ol class="list">
          <li class="item">
            <p class="item-title">1. 点击官网支持机型，查看是否支持：</p>

            <div class="pic-box">
              <img class="pic" src="./img/1.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">2. 把apk安装到手机中，然后运行</p>
          </li>

          <li class="item">
            <p class="item-title">3. 点击右上角</p>

            <div class="pic-box">
              <img class="pic" src="./img/2.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">4. 点击移除ROOT</p>

            <div class="pic-box">
              <img class="pic" src="./img/3.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">5. 弹出界面点击继续</p>

            <div class="pic-box">
              <img class="pic" src="./img/4.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">6. 会有提示</p>

            <div class="pic-box">
              <img class="pic" src="./img/5.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">7. 移除root会可能失败几次，多点几次就可以了</p>
          </li>
        </ol>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">2. 使用ROOT大师一键解除root</dt>

      <dd>
        <div class="link-box">
          <div>
            <span class="title">ROOT大师 官方网站</span>
            <a class="link" href="http://root.mgyun.com">http://root.mgyun.com</a>
          </div>

          <div>
            <span class="title">ROM基地 官方网站</span>
            <a class="link" href="http://www.romjd.com">http://www.romjd.com</a>
          </div>
        </div>

        <ol class="list">
          <li class="item">
            <p class="item-title">1. 先去官网查看你的手机是否支持</p>

            <div class="pic-box">
              <img class="pic" src="./img/6.png" alt="图例"/>
            </div>

            <div class="pic-box">
              <img class="pic" src="./img/7.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">
              <span>2. 官方教学网址</span>
              <a href="http://www.romjd.com/jiaocheng/content/10819">http://www.romjd.com/jiaocheng/content/10819</a>
            </p>
          </li>
        </ol>
      </dd>
    </dl>

    <!--<dl class="brand-tiem">
      <dt class="brand-title">3. 应用宝功能进行解除</dt>

      <dd>
        <div class="link-box">
          <span class="title">官网下载电脑版本应用宝</span>
          <a class="link" href="http://sj.qq.com/root/index.html">http://sj.qq.com/root/index.html</a>
        </div>

        <p class="desc">旧版本的应用宝进入工具箱内，如果你的手机处于已ROOT的状态，那么就会显示是解除ROOT。你直接点击进行还原就可以了，有的机器会检测不出ROOT状态。最新版5.7.1没有解触ROOT功能了，可以下载kingRoot官网 <a href="https://zh.kingroot.net/">https://zh.kingroot.net/</a> ，但是支持的版本相对较低，机型少。</p>
      </dd>
    </dl>-->

    <dl class="brand-tiem">
      <dt class="brand-title">3. 如果以上工具都无效</dt>

      <dd>
        <p class="desc">您可以联系官方客服4009-393-333咨询解决方式，我们将记录您的联系方式并尽力帮您解决问题。您也可以尝试使用刷机的方式重新安装操作系统来尝试解决问题。但是由于可能导致手机损坏或者数据丢失等风险，因此我们并不推荐您这样做。</p>
      </dd>
    </dl>

    <!--<dl class="brand-tiem">
      <dt class="brand-title">4. 强力一键root的PC版解除root权限</dt>

      <dd>
        <div class="link-box">
          <span class="title">官网</span>
          <a class="link" href="http://www.qiangliroot.com/">http://www.qiangliroot.com/</a>
        </div>

        <p class="desc">操作方法：将手机连接到电脑上，然后点击强力一键root软件界面中“移除ROOT”功能键即可。</p>

        <ol class="list">
          <li class="item">
            <p class="item-title">1：操作步骤如下图</p>

            <div class="pic-box">
              <img class="pic" src="./img/8.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">2：如果软件无法解决你的问题，那么就只能刷机了。根据自己手机的型号，到手机的官方网站下载ROM工具，然后按照官网提示进行刷机处理就好。不过这时候你手机中的所有数据也就别想要了。如果你没有备份，那么借助于强力安卓恢复精灵恢复也是可以的。</p>

            <div class="pic-box">
              <img class="pic" src="./img/9.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">操作方法：将手机连接到电脑上，打开强力安卓恢复精灵连接设备，然后选择要恢复数据的分区(Android手机一般有两分区，选择相应分区即可)，然后进行深度扫描，分区扫描过后，我们就会得到想要恢复的数据了。用户可以在软件左侧看见照片、微信、联系人等各种数据类型，还能够清楚看见具体恢复内容。选择性恢复或是全部恢复都可以。</p>

            <div class="pic-box">
              <img class="pic" src="./img/10.png" alt="图例"/>
            </div>
          </li>

          <li class="item">
            <p class="item-title">经过一段时间的新鲜，手机root已经不是我们的问题了，但是还是需要提醒大家，root需谨慎，了解root的好处和坏处，以及root后需要注意的状况，然后在进行root操作才是明智之举。</p>
          </li>
        </ol>
      </dd>
    </dl>-->

    <dl class="brand-tiem">
      <dt class="brand-title">模拟器关闭ROOT的方法</dt>

      <dd>
        <p class="desc">并非所有模拟器都支持非ROOT方式运行，因此如果您使用的不是以下五款模拟器（夜神，蓝叠，逍遥，雷电，二次元天天）之一，请您更换模拟器。</p>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">1.夜神模拟器</dt>

      <dd>
        <p class="desc">可以自由切换Root模式，点击界面右方的设置按钮可呼出如下图(此版本为6.0.6.1 2018/03/19，个别时候需要重启2次才生效)</p>

        <ol class="list">
          <li class="item">
            <div class="pic-box">
              <img class="pic" src="./img/11.png" alt="图例"/>
            </div>

            <div class="pic-box">
              <img class="pic" src="./img/12.png" alt="图例"/>
            </div>
          </li>
        </ol>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">2. 蓝叠模拟器</dt>

      <dd>
        <p class="desc">最新版本蓝叠3支持动态调整root（设置后需要重启模拟器）界面右上角点击如图:</p>

        <ol class="list">
          <li class="item">
            <div class="pic-box">
              <img class="pic" src="./img/13.png" alt="图例"/>
            </div>

            <div class="pic-box">
              <img class="pic" src="./img/14.png" alt="图例"/>
            </div>
          </li>
        </ol>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">3. 逍遥模拟器</dt>

      <dd>
        <p class="desc">支持动态设置ROOT模式，如下</p>

        <ol class="list">
          <li class="item">
            <div class="pic-box">
              <img class="pic" src="./img/15.png" alt="图例"/>
            </div>

            <div class="pic-box">
              <img class="pic" src="./img/16.png" alt="图例"/>
            </div>
          </li>
        </ol>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">4.雷电模式器</dt>

      <dd>
        <p class="desc">支持调整root权限，点击边框菜单栏里的设置</p>

        <ol class="list">
          <li class="item">
            <div class="pic-box">
              <img class="pic" src="./img/17.png" alt="图例"/>
            </div>

            <div class="pic-box">
              <img class="pic" src="./img/18.png" alt="图例"/>
            </div>
          </li>
        </ol>
      </dd>
    </dl>

    <dl class="brand-tiem">
      <dt class="brand-title">5.二次元天天模拟器</dt>

      <dd>
        <p class="desc">可以设置ROOT，在底部的菜单栏里如图：</p>

        <ol class="list">
          <li class="item">
            <div class="pic-box">
              <img class="pic" src="./img/19.png" alt="图例"/>
            </div>
          </li>
        </ol>
      </dd>
    </dl>
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'rootDoc'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "rootDoc.styl";
</style>



// WEBPACK FOOTER //
// src/views/rootDoc/rootDoc.vue